export default "__VITE_ASSET__CM_r$pvB__"